import { bitacoraRepository } from "../repositories/Bitacora.repository";

export const bitacoraService = {
    getBitacora
}

async function getBitacora (id) {
    const data = await bitacoraRepository.getBitacora(id);
    return data
}